export const Events = {
  SCREEN_VIEWED: "Screen Viewed",
}

export const BUSINESS_UNIT = "data services"

export const FLAG_ANALYTICS = "shell-enable-analytics-1"
